import Client from './Client';

export default class DistributionClinent {
  constructor() {
    this.client = Client;
  }

  /**
   * 获取平台分销记录
   */
  async distributionList(data) {
    const res = await this.client.post('/api/distribution/page', data);
    return res;
  }

  /**
   * 获取机构分销记录
   */
  async distributionAgencySummaryList(data) {
    const res = await this.client.post('/api/distribution/pageAgencySummary', data);
    return res;
  }

  /**
   * 获取学员分销记录
   */
  async distributionUserSummaryList(data) {
    const res = await this.client.post('/api/distribution/pageUserSummary', data);
    return res;
  }

  /**
   * 获取老师分销记录
   */
  async pageTeacherSummaryList(data) {
    const res = await this.client.post('/api/distribution/pageTeacherSummary', data);
    return res;
  }

  /**
   * 视频审核记录
   */
  async pageVideoAuditSummary(data) {
    const res = await this.client.post('/api/exam/pageVideoAuditSummary', data);
    return res;
  }
}